/**
 * Prefers Reduced Motion Settings
 *
 *  Checks for reduced motion setting and stores status in LocalStorage for use in other scripts.
 *
 */
export const motionQuery = matchMedia('(prefers-reduced-motion)');

/**
 * Live reduced-motion check, reading both signals at the moment of use: the OS media
 * query, and the localStorage flag this module mirrors it into for scripts that load
 * later. Never cache the result — the OS setting can change mid-session, and a value
 * captured once at init is what let the testimonial carousel resume a 10s autoplay
 * after the user had asked for less motion (FLYR-669).
 */
export const prefersReducedMotion = () => motionQuery.matches || localStorage.getItem('reduceMotion') === 'true';

const updateLocalStorage = (value) => {
    localStorage.setItem('reduceMotion', value);
};

const stopVideoAutoplay = () => {
    // Find all HTML5 video elements.
    const videos = document.querySelectorAll('video');
    videos.forEach((video) => {
        // Pause all videos with autoplay.
        const autoplay = video.getAttribute('autoplay');
        if (autoplay) {
            video.pause();
        }
    });
};

const reducedMotionCheck = () => {
    if (motionQuery.matches) {
        // Add functions for reduced motion here.
        if (process.env.NODE_ENV === 'development') {
            // eslint-disable-next-line no-console
            console.warn('[FLYWIRE]: Reduced Motion setting is active. Autoplay and animations have been turned off.');
        }
        updateLocalStorage(true);
        stopVideoAutoplay();
    } else {
        updateLocalStorage(false);
    }
};

reducedMotionCheck();
motionQuery.addEventListener('change', reducedMotionCheck);
